const initState = {
};

const reducer = (state = initState, action) => {
    switch (action.type) {
        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/views/CompanyRegistration/state/reducer.js